/**
 * Discounts API Queries
 *
 * Query keys and read operations.
 */

import { apiClient } from '../client';
import type { DiscountsListResponse, FetchDiscountsParams } from './types';
import type { DiscountResponse } from './mutations';

export const discountsQueryKeys = {
  all: ['discounts'] as const,
  lists: () => [...discountsQueryKeys.all, 'list'] as const,
  list: (params: FetchDiscountsParams) => [...discountsQueryKeys.lists(), params] as const,
  details: () => [...discountsQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...discountsQueryKeys.details(), id] as const,
};

export async function getDiscounts(params: FetchDiscountsParams = {}): Promise<DiscountsListResponse> {
  const { data } = await apiClient.get<DiscountsListResponse>('/api/discounts', { params });
  return data;
}

export async function getDiscount(id: number): Promise<DiscountResponse> {
  const { data } = await apiClient.get<DiscountResponse>(`/api/discounts/${id}`);
  return data;
}
